import { CSSProperties, FC, ReactNode } from 'react'
import cn from './index.module.css'
import classNames from 'classnames'
import { InfoCircleOutlined } from '@ant-design/icons'
import TooltipWrapper from '../TooltipWrapper/TooltipWrapper'

interface IFieldWrapper {
  label?: ReactNode
  tooltip?: ReactNode
  description?: string | null
  children: ReactNode
  extraContent?: ReactNode
  isInvalid?: boolean
  required?: boolean
  className?: string
  styles?: CSSProperties
  onClick?: () => void
}

const FieldWrapper: FC<IFieldWrapper> = ({
  children,
  label,
  tooltip,
  description,
  isInvalid,
  required,
  extraContent,
  className,
  styles,
  onClick,
}) => {
  return (
    <div className={classNames(cn.wrapper, className)} style={styles}>
      {(label || tooltip || extraContent) && (
        <div className={cn.header} onClick={onClick}>
          <div className={cn.labelWrapper}>
            <span className={classNames(cn.label, isInvalid && cn.invalid)}>
              {label}
              {required && (
                <span className={cn.requiredMark} aria-hidden="true">
                  *
                </span>
              )}
            </span>
            {tooltip && (
              <TooltipWrapper title={tooltip}>
                <InfoCircleOutlined
                  className={cn.tooltipIcon}
                  onPointerEnterCapture={undefined}
                  onPointerLeaveCapture={undefined}
                />
              </TooltipWrapper>
            )}
          </div>
          {extraContent}
        </div>
      )}
      {children}
      {description && typeof description === 'string' && (
        <span className={cn.description}>{description}</span>
      )}
      {description && typeof description !== 'string' && description}
    </div>
  )
}

export default FieldWrapper
